module.exports = __webpack_public_path__ + "static/media/whatsapp.2996fc11.png";